import { render, staticRenderFns } from "./NotificationsAdminDetails.vue?vue&type=template&id=6da46e9a&"
import script from "./NotificationsAdminDetails.vue?vue&type=script&lang=js&"
export * from "./NotificationsAdminDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports